// experimentAssignment shape (top-level field from routing-service POST body):
// {
//   assignments: {
//     [experimentKey]: {   // e.g. "gbdemo-checkout-layout"
//       value: any,            // variant value — string, number, or boolean
//       variationIndex: number, // 0 = control, 1+ = variants
//     }
//     // presence of a key means the user IS in that experiment
//   },
//   pageViewEventId: string,   // UUID correlating exposure to page view in Kinesis/Snowflake
// }
export const state = {
  assignments: {},
  pageViewEventId: null,
};
